import { CommonHttp } from "@/models/interfaces/http/common.http.request";
import {SearchedClient} from "@/store/search";


type ProjectResponse = {
    Projects: any[],
    StageSets: any[],
    ProjectCount: number,
}

type ClientsResponse = {
    Clients: SearchedClient[],
    ClientCount: number,
}

export type SearchClientFilter = {
    id: number,
    roles: number[],
    useUnion: boolean,
}

export class SearchApi {
    // Получение количества всех пользователей
    static getClientsCount():  Promise<number> {
        const http = new CommonHttp()
        return http
            .get('clients/count')
            .then(data => data.data)
    }

    // Получение стартового списка клиентов
    static getInitClients(filter?: string, tags?: number[]):  Promise<ClientsResponse> {
        const http = new CommonHttp()
        return http
            .get(`clients/search/initial?Count=30${filter ? `&Filter=${filter}` : ''}${tags ? tags.map(t => `&Tags=${t}`).join('') : ''}`)
            .then(data => data.data)
    }

    // Получение стартового списка клиентов
    static getClientsPartial(filter?: string, tags?: number[], skipFrom?: string):  Promise<ClientsResponse> {
        const http = new CommonHttp()
        return http
            .get(`clients/search/aditional?Count=30${filter ? `&Filter=${filter}` : ''}${skipFrom ? `&SkipFrom=${skipFrom}` : ''}${tags ? tags.map(t => `&Tags=${t}`).join('') : ''}`)
            .then(data => data.data)
    }

    // Получение стартового списка проектов
    static getInitProjects():  Promise<ProjectResponse> {
        const http = new CommonHttp()
        return http
            .post(`projects/search/initial`, { count: 30 })
            .then(data => data.data)
    }

    // Получение списка проектов
    static getProjects(stages: number[], tags: number[], nameFilter: string, clients: SearchClientFilter[] = []):  Promise<ProjectResponse> {
        const http = new CommonHttp()
        return http
            .post(`projects/search/initial`, {
                count: 30,
                stages,
                tags,
                clients: clients || [],
                ...(nameFilter ? { nameFilter } : {}),
            })
            .then(data => data.data)
    }

    // Получение новой порции списка проектов
    static getProjectsPartion(stages: number[], tags: number[], nameFilter: string, date: string, clients: SearchClientFilter[] = []):  Promise<ProjectResponse> {
        const http = new CommonHttp()
        return http
            .post(`projects/search/initial/add`, {
                Count: 30,
                date,
                stages,
                tags,
                clients: clients || [],
                ...(nameFilter ? { nameFilter } : {}),
            })
            .then(data => data.data)
    }
}
